import { StoreActionApi } from 'react-sweet-state';
import { AxiosInstance } from 'axios';
import { FileRejection } from '@unfold/dropzone';

export enum MediaType {
  Color = 100,
  Sticker = 200,
  Font = 300,
  Logo = 500.
}

export interface IMedia {
  created_at: number;
  desc: string;
  display_name?: string;
  id: number;
  size: number;
  type: MediaType;
  uuid: string;
  value: string;
}

export interface IFile extends File {
  progress?: number;
}

export type TExportResponse = {
  status: string;
  timestamp: number;
  link: string;
  msg: string;
};

export type TState = {
  mediaItems: IMedia[];
  acceptedFiles: IFile[];
  progressingFiles: {
    [x: string]: number;
  };
  loading: boolean;
  downloadURL: string;
  exportURL: string;
  exporting: boolean;
  importing: boolean;
  importURL: string;
  importId: string;
  error: string;
  isImportExportModalOpen: boolean;
};

export type TStoreApi = StoreActionApi<TState>;
export type TContainerProps = { api: AxiosInstance };
export type TFileRejection = FileRejection;
